/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { MovementWaypoint } from "./movement_waypoint";

export const protobufPackage = "planner";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface SpatialWaypointsCommand {
  creationUtime: number;
  sampleUtime: number;
  positionAggressiveness: number;
  velocityAggressiveness: number;
  maxAcceleration: number;
  spatialWaypoints: MovementWaypoint[];
}

function createBaseSpatialWaypointsCommand(): SpatialWaypointsCommand {
  return {
    creationUtime: 0,
    sampleUtime: 0,
    positionAggressiveness: 0,
    velocityAggressiveness: 0,
    maxAcceleration: 0,
    spatialWaypoints: [],
  };
}

export const SpatialWaypointsCommand = {
  encode(message: SpatialWaypointsCommand, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.creationUtime !== 0) {
      writer.uint32(8).sint64(message.creationUtime);
    }
    if (message.sampleUtime !== 0) {
      writer.uint32(16).sint64(message.sampleUtime);
    }
    if (message.positionAggressiveness !== 0) {
      writer.uint32(29).float(message.positionAggressiveness);
    }
    if (message.velocityAggressiveness !== 0) {
      writer.uint32(37).float(message.velocityAggressiveness);
    }
    if (message.maxAcceleration !== 0) {
      writer.uint32(45).float(message.maxAcceleration);
    }
    for (const v of message.spatialWaypoints) {
      MovementWaypoint.encode(v!, writer.uint32(50).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpatialWaypointsCommand {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSpatialWaypointsCommand();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.creationUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.sampleUtime = longToNumber(reader.sint64() as Long);
          continue;
        case 3:
          if (tag !== 29) {
            break;
          }

          message.positionAggressiveness = reader.float();
          continue;
        case 4:
          if (tag !== 37) {
            break;
          }

          message.velocityAggressiveness = reader.float();
          continue;
        case 5:
          if (tag !== 45) {
            break;
          }

          message.maxAcceleration = reader.float();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.spatialWaypoints.push(MovementWaypoint.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SpatialWaypointsCommand {
    return {
      creationUtime: isSet(object.creationUtime) ? globalThis.Number(object.creationUtime) : 0,
      sampleUtime: isSet(object.sampleUtime) ? globalThis.Number(object.sampleUtime) : 0,
      positionAggressiveness: isSet(object.positionAggressiveness)
        ? globalThis.Number(object.positionAggressiveness)
        : 0,
      velocityAggressiveness: isSet(object.velocityAggressiveness)
        ? globalThis.Number(object.velocityAggressiveness)
        : 0,
      maxAcceleration: isSet(object.maxAcceleration) ? globalThis.Number(object.maxAcceleration) : 0,
      spatialWaypoints: globalThis.Array.isArray(object?.spatialWaypoints)
        ? object.spatialWaypoints.map((e: any) => MovementWaypoint.fromJSON(e))
        : [],
    };
  },

  toJSON(message: SpatialWaypointsCommand): unknown {
    const obj: any = {};
    if (message.creationUtime !== 0) {
      obj.creationUtime = Math.round(message.creationUtime);
    }
    if (message.sampleUtime !== 0) {
      obj.sampleUtime = Math.round(message.sampleUtime);
    }
    if (message.positionAggressiveness !== 0) {
      obj.positionAggressiveness = message.positionAggressiveness;
    }
    if (message.velocityAggressiveness !== 0) {
      obj.velocityAggressiveness = message.velocityAggressiveness;
    }
    if (message.maxAcceleration !== 0) {
      obj.maxAcceleration = message.maxAcceleration;
    }
    if (message.spatialWaypoints?.length) {
      obj.spatialWaypoints = message.spatialWaypoints.map((e) => MovementWaypoint.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SpatialWaypointsCommand>, I>>(base?: I): SpatialWaypointsCommand {
    return SpatialWaypointsCommand.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SpatialWaypointsCommand>, I>>(object: I): SpatialWaypointsCommand {
    const message = createBaseSpatialWaypointsCommand();
    message.creationUtime = object.creationUtime ?? 0;
    message.sampleUtime = object.sampleUtime ?? 0;
    message.positionAggressiveness = object.positionAggressiveness ?? 0;
    message.velocityAggressiveness = object.velocityAggressiveness ?? 0;
    message.maxAcceleration = object.maxAcceleration ?? 0;
    message.spatialWaypoints = object.spatialWaypoints?.map((e) => MovementWaypoint.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
